export const taxesCalculation = (row, index) => {
	const item = row[index];
	if (Number(item?.mrp) !== 0 && Number(item?.quantity) !== 0) {
		const isSellLoose = Boolean(item?.sell_loose);
		const contains = Number(item?.contains) || 1;
		const effectiveUnitPrice =
			isSellLoose && contains > 0
				? Number(item.mrp) / contains
				: Number(item.mrp);
		let totalTaxes = Number(item?.product_tax1 || 0) + Number(item?.product_tax2 || 0);
		let totalLineGross = effectiveUnitPrice * Number(item.quantity);
		let baseAmount =
			totalLineGross -
			Number(
				(totalLineGross * Number(totalTaxes)) /
					Number(100 + Number(totalTaxes)),
			);
		let newRow = [...row];
		newRow[index].unit_price = Number(effectiveUnitPrice).toFixed(2);
		newRow[index].amount = Number(baseAmount).toFixed(2);
		return newRow;
	} else {
		return row;
	}
};
export const totalAmountWithoutTax = (amount, tax1, tax2) => {
	let totalTaxes = Number(tax1) + Number(tax2);
	let baseAmount =
		Number(amount) -
		Number((Number(amount) * Number(totalTaxes)) / Number(100 + Number(totalTaxes)));
	return Number(baseAmount).toFixed(2);
};
export const getRoundedOffAmount = (amount) => {
	const roundedTotal = amount % 1 >= 0.5 ? Math.ceil(amount) : Math.floor(amount);
	return Number(roundedTotal).toFixed(2);
};

export const getRoundedOff = (amount) => {
	const roundedTotal = amount % 1 >= 0.5 ? Math.ceil(amount) : Math.floor(amount);
	const roundOff = parseFloat((roundedTotal - amount).toFixed(2));
	return roundOff;
};
